import React from "react";
import "./App.css";
import { getPageTitle } from "./constants";
import {
  CareerApplicationForm,
  BranchLocatorForm,
  BecomeAdvisorForm,
  Contactpartners,
  UnclaimedDetailsForm,
  TrackGrievanceStatusForm,
  CreateGrievanceRedressalForm,
  NavFundDetailsForm,
  TrackClaimForm,
  GroupPolicyForm,
  BlogDetails,
  ClaimIntimationForm,
  OurFundsForm,
  EcsPremiumOffsetConsentForm,
} from "./forms";
import AiHubForm from "./forms/aiHub/AiHbForm";
import CustomerReviewForm from "./forms/customreReview/CustomerReviewForm";


// Future-ready mapping for multiple corporate forms
const FORM_CONFIGS = {
  careerApplication: {
    label: "Career Application",
    component: CareerApplicationForm,
  },
  branchLocator: {
    label: "Branch Locator",
    component: BranchLocatorForm,
  },
  becomeApplication: {
    label: "Become Application",
    component: BecomeAdvisorForm,
  },
  contactpartners: {
    label: "Contact Partners",
    component: Contactpartners,
  },
  unclaimedAmount: {
    label: "Unclaimed Amount",
    component: UnclaimedDetailsForm,
  },
  unclaimedSeniorCitizen: {
    label: "Unclaimed Amount (Senior Citizen)",
    component: UnclaimedDetailsForm,
  },
  trackGrievanceStatus: {
    label: "Track Grievance Status",
    component: TrackGrievanceStatusForm,
  },
  createGrievanceRedressal: {
    label: "Create Grievance Redressal",
    component: CreateGrievanceRedressalForm,
  },
  navFundDetails: {
    label: "Nav Fund Details",
    component: NavFundDetailsForm,
  },
  groupPolicyForm: {
    label: "Group Policy Form",
    component: GroupPolicyForm,
  },
  trackClaimCustomer: {
    label: "Track Claim Customer",
    component: TrackClaimForm,
  },
  claimIntimationCustomer: {
    label: "Track Claim Customer",
    component: ClaimIntimationForm,
  },
  ourFundsForm: {
    label: "Our Funds Form",
    component: OurFundsForm,
  },
  aiHubForm: {
    label: "AI Hub Form",
    component: AiHubForm,
  },

  customerReviewForm: {
    label: "Customer Review Form",
    component: CustomerReviewForm,
  },

  blogDetails: {
    label: "Blog Details",
    component: BlogDetails,
  },

  ecsPremiumOffsetConsent: {
    label: "ECS Premium Offset Consent",
    component: EcsPremiumOffsetConsentForm,
  },
};

function App({ formType = "careerApplication" }) {
  const config = FORM_CONFIGS[formType] || FORM_CONFIGS.careerApplication;
  const FormComponent = config.component;
  const pageTitle = getPageTitle();
  return (
    <div className="corporate-forms-container">
      <FormComponent pageTitle={pageTitle} formType={formType} />
    </div>
  );
}

export default App;
